import { ComponentConfig } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../page-builder/puck/reusable-props/margin';
import { IAsset } from '../../../page-builder/interface/apiServiceInterface';
import { imageField } from '../../../page-builder/puck/reusable-props/image';
import {
  ImageProps,
  imageProps,
} from '../../../page-builder/puck/reusable-props/image-props';
import { CartIcon } from '../../../assets/icons/cartIcon';
import { PlusIcon } from '@heroicons/react/20/solid';
import { ReduxSelectorProps } from '../../services/constants';
import { AxiosInstance } from 'axios';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import CustomTooltip from '../../../components/common/tooltip';
import { getIsEdit } from '../../utils/constants';
import TextCustomInput from '../../puck/reusable-props/TextCustomInput';
import { CustomizeProps } from '../../interface/commonInterface';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import './../text-editor/style.scss';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
  resolveShowComponentField,
} from '../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import {
  BackgroudImageProps,
  backgroundImageProps,
} from '../../puck/reusable-props/background-image-props';
import ShowLogo from './ShowLogo';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import { useState } from 'react';

export type SimplePageHeaderProps = {
  imageFile: IAsset;
  backgroundImageFile: IAsset;
  absolute: boolean;
  logoAlign: boolean;
  header: CustomizeProps;
  secureConnection: string;
  fetchPriority: boolean;
  show: {
    device: string;
    cartColor: string;
    show: {
      [key: string]: string;
      mobile: string;
      tablet: string;
      desktop: string;
    };
  };
  background: {
    color: string;
    isInherit: boolean;
  };
  border: IBorderValueProps;
} & MarginProps &
  ImageProps &
  BackgroudImageProps &
  showComponentProps &
  PaddingProps;

export interface SimplePageComponentProps extends ReduxSelectorProps {
  baseService: AxiosInstance;
}
export const SimplePageHeader = ({
  useAppSelector,
  baseService,
}: SimplePageComponentProps): ComponentConfig<SimplePageHeaderProps> => {
  return {
    label: (
      <CustomTooltip title="SimplePageHeader">
        <span>Simple Page Header</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...paddingFields,
      ...marginFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...backgroungFields,
      show: {
        type: 'custom',
        label: 'Show',
        render: ({ value, onChange }) => {
          return <ShowLogo value={value} onChange={onChange} />;
        },
      },
      header: {
        type: 'custom',
        label: 'Header Text',
        render: ({ value, onChange, field }) => (
          <TextCustomInput
            showComponent={true}
            showHover={true}
            value={value}
            onChange={onChange}
            title={field?.label}
          />
        ),
      },
      secureConnection: {
        ...QuillTextEditor('Secure Connection').content,
      },
      imageFile: { ...imageField(true, baseService).file },
      ...imageProps([]),
      fetchPriority: {
        type: 'radio',
        label: 'Fetch Priority',
        options: [
          { label: 'On', value: true },
          { label: 'Off', value: false },
        ],
      },
      backgroundImageFile: { ...imageField(false, baseService).file },
      ...backgroundImageProps([]),
      logoAlign: {
        type: 'radio',
        label: 'Logo Align',
        options: [
          { label: 'Left', value: true },
          { label: 'Center', value: false },
        ],
      },
      absolute: {
        type: 'radio',
        label: 'Absolute',
        options: [
          { label: 'True', value: true },
          { label: 'False', value: false },
        ],
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      header: {
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        deviceType: 'desktop',
        text: 'My Store',
        textColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        hoverColor: {
          mobile: '#181C14',
          tablet: '#181C14',
          desktop: '#181C14',
        },
        showComponent: {
          mobile: true,
          tablet: true,
          desktop: true,
        },
        fontSize: {
          mobile: 'text-2xl',
          tablet: 'text-2xl',
          desktop: 'text-2xl',
        },
      },
      secureConnection: '<p style="line-height:1.5;">Secure Connection</p>',
      fetchPriority: false,
      backgroundImageFile: {
        storeID: '',
        fileName: 'background',
        imageUrl: '',
      },
      imageFile: {
        storeID: '',
        fileName: 'logo',
        imageUrl: '',
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '18',
          mobile: '18',
          tablet: '18',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '18',
          mobile: '18',
          tablet: '16',
        },
      },
      ...borderProps,
      image: {
        height: {
          desktop: '100',
          mobile: '100',
          tablet: '100',
        },
        maxWidth: {
          desktop: '100',
          mobile: '100',
          tablet: '100',
        },
        deviceType: 'desktop',
      },
      bg_image: {
        backgroundPosition: 'bg-center',
        backgroundRepeat: 'bg-no-repeat',
        backgroundSize: 'bg-cover',
      },
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      absolute: false,
      logoAlign: true,
      show: {
        device: 'desktop',
        cartColor: '#2d71ab',
        show: {
          mobile: 'cart',
          tablet: 'cart',
          desktop: 'cart',
        },
      },
    },
    resolveFields: ({ props }, { fields }) =>
      resolveShowComponentField(props.id, fields),
    render: ({
      imageFile,
      backgroundImageFile,
      margin,
      padding,
      border,
      image,
      bg_image,
      logoAlign,
      absolute,
      secureConnection,
      header,
      show,
      showComponent,
      background,
      editMode,
      fetchPriority,
    }) => {
      const isEditModeOn = getIsEdit();
      const storeData = useAppSelector(state => state.store.storeData);
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);

      const handleClick = () => {
        if (storeData?.DomainURL) {
          window.location.href = `https://${storeData.DomainURL}`;
        }
      };
      const state = useAppSelector(state => state);
      const newHeader = {
        ...header,
        text: getQuillEditorText(header?.text, state),
      };
      const newSecureConnection = getQuillEditorText(secureConnection, state);
      const url = process.env.REACT_APP_S3_BUCKET_URL + imageFile.imageUrl;

      const backgroundUrl = backgroundImageFile.imageUrl
        ? process.env.REACT_APP_S3_BUCKET_URL + backgroundImageFile.imageUrl
        : '';
      const imgHeight = isNaN(+image?.height[currentDeviceType])
        ? image?.height[currentDeviceType]
        : +image?.height[currentDeviceType];
      const imgWidth = isNaN(+image?.maxWidth[currentDeviceType])
        ? image?.maxWidth[currentDeviceType]
        : +image?.maxWidth[currentDeviceType];
      const htmlWidth = imageFile?.width;
      const htmlHeight = imageFile?.height;
      const [isLoaded, setIsLoaded] = useState(false);
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              className={`flex justify-between items-center w-full standardLayoutPadding ${border?.borderStyle?.[currentDeviceType]}
              max-[760px]:!bg-none ${absolute ? 'absolute' : ''} md:relative top-0 left-0 right-0
             ${newHeader.fontSize?.[currentDeviceType]} ${newHeader.weight?.[currentDeviceType]}
             ${bg_image?.backgroundPosition}
            ${bg_image?.backgroundRepeat}
            ${bg_image?.backgroundSize}         
          `}
              style={{
                backgroundImage: `url(${backgroundUrl})`,
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                ...getBorderProps(border, currentDeviceType),
              }}>
              {logoAlign === false && <div></div>}
              <div className="flex cursor-pointer" onClick={handleClick}>
                {imageFile?.imageUrl ? (
                  <img
                    src={url}
                    alt={imageFile?.fileName}
                    width={htmlWidth}
                    height={htmlHeight}
                    fetchPriority={fetchPriority ? 'high' : undefined}
                    style={
                      isLoaded
                        ? {
                            width: imgWidth,
                            height: imgHeight,
                          }
                        : { maxHeight: imgHeight, maxWidth: imgWidth }
                    }
                    onLoad={() => setIsLoaded(true)}
                  />
                ) : isEditModeOn ? (
                  <button
                    type="button"
                    className="flex rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-page_builder_theme">
                    Upload Logo
                    <PlusIcon aria-hidden="true" className="h-5 w-5" />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="flex rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300">
                    Logo
                  </button>
                )}
              </div>
              {logoAlign === false &&
                !newHeader?.showComponent?.[currentDeviceType] &&
                !show && <div></div>}

              {newHeader.text &&
                newHeader?.showComponent?.[currentDeviceType] && (
                  <div className="flex items-center justify-center h-full overflow-hidden">
                    <p
                      className={`${newHeader.fontSize?.[currentDeviceType]} ${newHeader.weight?.[currentDeviceType]}`}
                      style={{
                        color: newHeader.textColor?.[currentDeviceType],
                      }}
                      onMouseEnter={event =>
                        newHeader.hoverColor &&
                        (event.currentTarget.style.color =
                          newHeader.hoverColor?.[currentDeviceType])
                      }
                      onMouseLeave={event =>
                        (event.currentTarget.style.color =
                          newHeader.textColor?.[currentDeviceType])
                      }>
                      {newHeader.text}
                    </p>
                  </div>
                )}

              {show?.show?.[currentDeviceType] ? (
                <div className="flex items-center cursor-pointer h-[26px]">
                  {show?.show?.[currentDeviceType] === 'cart' ? (
                    <div onClick={handleClick}>
                      <CartIcon color={show?.cartColor} />
                    </div>
                  ) : (
                    show?.show?.[currentDeviceType] === 'secure' && (
                      <dd className=" text-editor-content text-sm font-bold block cursor-auto">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          fill="green"
                          className="h-3 w-3 inline-block align-middle mb-1 mr-1">
                          <path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z" />
                        </svg>
                        <div
                          style={{ display: 'inline-block', lineHeight: 1.5 }}
                          dangerouslySetInnerHTML={{
                            __html: newSecureConnection,
                          }}
                        />
                      </dd>
                    )
                  )}
                </div>
              ) : (
                <div />
              )}
            </div>
          )}
        </>
      );
    },
  };
};
